// Import the functions you need from the SDKs you need
import { initializeApp, setLogLevel } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, onAuthStateChanged, onIdTokenChanged, initializeAuth, connectAuthEmulator, indexedDBLocalPersistence, browserLocalPersistence, browserSessionPersistence } from "firebase/auth";
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyCsl1BRFkZNJRnIjeyUAR1l0VRSmgccyzM",
  authDomain: "beawareconfcapportal.firebaseapp.com",
  projectId: "beawareconfcapportal",
  storageBucket: "beawareconfcapportal.appspot.com",
  messagingSenderId: "315608168836",
  appId: "1:315608168836:web:4c6fc6be8c3d7cf31745d1",
  measurementId: "G-0LVRKJGVDT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// getAuth() only uses IndexedDB. When that database is stuck (a broken profile, a blocked upgrade from another tab) the
// login state never resolves and the portal shows its spinner forever; listing fallbacks lets it fall through to localStorage.
try {
  initializeAuth(app, { persistence: [indexedDBLocalPersistence, browserLocalPersistence, browserSessionPersistence] });
} catch (error) {
  getAuth(app); // already initialised (hot reload)
}
// Local testing only: REACT_APP_USE_AUTH_EMULATOR=true points sign-in at the Auth emulator (`npm run emulators`) instead of the live project.
if (process.env.REACT_APP_USE_AUTH_EMULATOR === "true") {
  connectAuthEmulator(getAuth(app), "http://127.0.0.1:9099", { disableWarnings: true });
}
// Timing logs for the stuck-login investigation: when does Firebase first answer "who is signed in"?
const authStartedAt = performance.now();
const sinceStart = () => `${Math.round(performance.now() - authStartedAt)}ms`;
if (window.location.href.includes("debug")) setLogLevel("debug"); // add "debug" anywhere in the URL for Firebase's own logs
console.log("[auth] initialised, waiting for the saved sign-in to resolve");
onAuthStateChanged(getAuth(app), (user) => console.log(`[auth] onAuthStateChanged after ${sinceStart()}: ${user ? "signed in" : "signed out"}`));
onIdTokenChanged(getAuth(app), (user) => console.log(`[auth] onIdTokenChanged after ${sinceStart()}: ${user ? "token" : "no user"}`));
getAuth(app).authStateReady().then(() => console.log(`[auth] authStateReady after ${sinceStart()}`));
const analytics = getAnalytics(app);
const database = getDatabase(app);

export { app, analytics, database };